import { PowerBIPremiumReport } from "../powerbi-premium/PowerBIPremiumReport";
import { PowerBIReport } from "../powerbi/PowerBIReport";
import { SSRSReport } from "../ssrs/SSRSReport";


export const reportRenderers: Record<string, any> = {
  "1": SSRSReport,
  "2": PowerBIReport,
  "3": PowerBIPremiumReport,
};
